<script setup>
import VDevider from "@/Shared/VDevider.vue";
import VButtonSubmit from "@/Shared/Buttons/VButtonSubmit";
import VInputReadonlyWithLabel from "../../Form/VInputReadonlyWithLabel.vue";
import VInputWithLabel from "../../Form/VInputWithLabel.vue";

import { useForm } from "@inertiajs/vue3";

const props = defineProps({
    additional: Object,
});

const { surveyFields, answers } = props.additional;

const form = useForm({
    please_select_your_currency: answers?.please_select_your_currency,
    please_indicate_the_number_of_people_covered_for_the_overall_travel_spending:
        answers?.please_indicate_the_number_of_people_covered_for_the_overall_travel_spending,
    flights: answers?.flights,
    accommodation: answers?.accommodation,
    food_and_beverages: answers?.food_and_beverages,
    activities: answers?.activities,
    events: answers?.events,
    transportation: answers?.transportation,
    optional_tours: answers?.optional_tours,
    fuel: answers?.fuel,
    shopping: answers?.shopping,
    local_transfer_transportation: answers?.local_transfer_transportation,
    vehicle_rental: answers?.vehicle_rental,
    sports: answers?.sports,
    healthmedical_treatment: answers?.healthmedical_treatment,
    wellness: answers?.wellness,
    others_lump_sum: answers?.others_lump_sum,
    how_many_nights_did_you_spend_in_sabah:
        answers?.how_many_nights_did_you_spend_in_sabah,
});

const emits = defineEmits("onNext");

const handleClickNext = () => {
    emits("onNext", form.data());
};
</script>

<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="mb-3">
                    <VInputReadonlyWithLabel
                        elId="please_select_your_currency"
                        v-model:value="form.please_select_your_currency"
                        :widthLabel="4"
                        :widthInput="8"
                        :label="
                            surveyFields['please_select_your_currency']?.name
                        "
                        :isPlainText="false"
                    />
                </div>
                <div class="mb-3">
                    <VInputReadonlyWithLabel
                        elId="please_indicate_the_number_of_people_covered_for_the_overall_travel_spending"
                        v-model:value="
                            form.please_indicate_the_number_of_people_covered_for_the_overall_travel_spending
                        "
                        :widthLabel="4"
                        :widthInput="8"
                        :label="
                            surveyFields[
                                'please_indicate_the_number_of_people_covered_for_the_overall_travel_spending'
                            ]?.name
                        "
                        :isPlainText="false"
                    />
                </div>
                <VDevider />
                <div class="mb-4">
                    <p class="fw-bold mb-3">
                        What are your rough estimates of expenses for these
                        categories? (includes package tours/self-arranged)
                    </p>

                    <div class="mb-1">
                        <VInputReadonlyWithLabel
                            elId="flights"
                            v-model:value="form.flights"
                            :widthLabel="4"
                            :widthInput="8"
                            type="number"
                            :label="surveyFields['flights']?.name"
                            :isPlainText="false"
                        />
                    </div>
                    <div class="mb-1">
                        <VInputReadonlyWithLabel
                            elId="accommodation"
                            v-model:value="form.accommodation"
                            :widthLabel="4"
                            :widthInput="8"
                            type="number"
                            :label="surveyFields['accommodation']?.name"
                            :isPlainText="false"
                        />
                    </div>
                    <div class="mb-1">
                        <VInputReadonlyWithLabel
                            elId="food_and_beverages"
                            v-model:value="form.food_and_beverages"
                            :widthLabel="4"
                            :widthInput="8"
                            type="number"
                            :label="surveyFields['food_and_beverages']?.name"
                            :isPlainText="false"
                        />
                    </div>
                    <div class="mb-1">
                        <VInputReadonlyWithLabel
                            elId="activities"
                            v-model:value="form.activities"
                            :widthLabel="4"
                            :widthInput="8"
                            type="number"
                            :label="surveyFields['activities']?.name"
                            :isPlainText="false"
                        />
                    </div>
                    <div class="mb-1">
                        <VInputReadonlyWithLabel
                            elId="events"
                            v-model:value="form.events"
                            :widthLabel="4"
                            :widthInput="8"
                            type="number"
                            :label="surveyFields['events']?.name"
                            :isPlainText="false"
                        />
                    </div>
                    <div class="mb-1">
                        <VInputReadonlyWithLabel
                            elId="transportation"
                            v-model:value="form.transportation"
                            :widthLabel="4"
                            :widthInput="8"
                            type="number"
                            :label="surveyFields['transportation']?.name"
                            :isPlainText="false"
                        />
                    </div>
                    <div class="mb-1">
                        <VInputReadonlyWithLabel
                            elId="optional_tours"
                            v-model:value="form.optional_tours"
                            :widthLabel="4"
                            :widthInput="8"
                            type="number"
                            :label="surveyFields['optional_tours']?.name"
                            :isPlainText="false"
                        />
                    </div>
                    <div class="mb-1">
                        <VInputReadonlyWithLabel
                            elId="fuel"
                            v-model:value="form.fuel"
                            :widthLabel="4"
                            :widthInput="8"
                            type="number"
                            :label="surveyFields['fuel']?.name"
                            :isPlainText="false"
                        />
                    </div>
                    <div class="mb-1">
                        <VInputReadonlyWithLabel
                            elId="shopping"
                            v-model:value="form.shopping"
                            :widthLabel="4"
                            :widthInput="8"
                            type="number"
                            :label="surveyFields['shopping']?.name"
                            :isPlainText="false"
                        />
                    </div>
                    <div class="mb-1">
                        <VInputReadonlyWithLabel
                            elId="local_transfer_transportation"
                            v-model:value="form.local_transfer_transportation"
                            :widthLabel="4"
                            :widthInput="8"
                            type="number"
                            :label="
                                surveyFields['local_transfer_transportation']
                                    ?.name
                            "
                            :isPlainText="false"
                        />
                    </div>
                    <div class="mb-1">
                        <VInputReadonlyWithLabel
                            elId="vehicle_rental"
                            v-model:value="form.vehicle_rental"
                            :widthLabel="4"
                            :widthInput="8"
                            type="number"
                            :label="surveyFields['vehicle_rental']?.name"
                            :isPlainText="false"
                        />
                    </div>
                    <div class="mb-1">
                        <VInputReadonlyWithLabel
                            elId="sports"
                            v-model:value="form.sports"
                            :widthLabel="4"
                            :widthInput="8"
                            type="number"
                            :label="surveyFields['sports']?.name"
                            :isPlainText="false"
                        />
                    </div>
                    <div class="mb-1">
                        <VInputReadonlyWithLabel
                            elId="healthmedical_treatment"
                            v-model:value="form.healthmedical_treatment"
                            :widthLabel="4"
                            :widthInput="8"
                            type="number"
                            :label="
                                surveyFields['healthmedical_treatment']?.name
                            "
                            :isPlainText="false"
                        />
                    </div>
                    <div class="mb-1">
                        <VInputReadonlyWithLabel
                            elId="wellness"
                            v-model:value="form.wellness"
                            :widthLabel="4"
                            :widthInput="8"
                            type="number"
                            :label="surveyFields['wellness']?.name"
                            :isPlainText="false"
                        />
                    </div>
                    <div class="mb-1">
                        <VInputReadonlyWithLabel
                            elId="others_lump_sum"
                            v-model:value="form.others_lump_sum"
                            :widthLabel="4"
                            :widthInput="8"
                            type="number"
                            :label="surveyFields['others_lump_sum']?.name"
                            :isPlainText="false"
                        />
                    </div>
                </div>
                <VDevider class="mb-4" />
                <div class="mb-3">
                    <VInputReadonlyWithLabel
                        elId="how_many_nights_did_you_spend_in_sabah"
                        v-model:value="
                            form.how_many_nights_did_you_spend_in_sabah
                        "
                        :widthLabel="4"
                        :widthInput="8"
                        type="number"
                        :label="
                            surveyFields[
                                'how_many_nights_did_you_spend_in_sabah'
                            ]?.name
                        "
                        :isPlainText="false"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
